import { useState, useEffect } from 'react';

/**
 * useTeamData Hook
 * Fetches team lead data for recruiters
 * 
 * @param {Object} selectedUser - Current user object
 * @param {Object} myTeam - User's team object
 * @returns {Object} { teamLead, loading, error }
 */
const useTeamData = (selectedUser, myTeam) => {
  const [teamLead, setTeamLead] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

  useEffect(() => {
    const fetchTeamLead = async () => {
      // Only fetch if user is a recruiter and has a team
      if (!selectedUser || selectedUser.role !== 'recruiter' || !myTeam?.team_lead_id) {
        setTeamLead(null);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const response = await fetch(`${BACKEND_URL}/api/users`);
        
        if (!response.ok) {
          throw new Error('Failed to fetch users');
        }

        const data = await response.json();
        const lead = data.users?.find(u => u.id === myTeam.team_lead_id);
        
        if (lead) {
          setTeamLead(lead);
        } else {
          setError('Team lead not found');
        }
      } catch (err) {
        console.error('Error fetching team lead:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTeamLead();
  }, [selectedUser, myTeam, BACKEND_URL]);

  return { teamLead, loading, error };
};

export default useTeamData;
